import { fetchFromRTM } from './index';
import * as constants from './constants';
import './typedef';

class RecentActivityResolver {
  constructor(connection) {
    this.connection = connection;
  }
  
  /**
   * Get Recent List for the user
   *  
   * @param {string} accountId
   * @returns {Promise.<void>}
   */
   getRecentActivityList = async (accountId) => {
     const message = {
       type: constants.RTM_GET_USER_RECENT_VIEWED,
       accountId: accountId,
     };

     const response = await fetchFromRTM(
       this.connection,
       message,
       constants.RTM_GET_USER_RECENT_VIEWED_OK,
       constants.RTM_GET_USER_RECENT_VIEWED_ERROR,
     );

     return response;
   };
}

export default RecentActivityResolver;
